import { render, staticRenderFns } from "./AdminArea.vue?vue&type=template&id=34b841d5&"
import script from "./AdminArea.vue?vue&type=script&lang=js&"
export * from "./AdminArea.vue?vue&type=script&lang=js&"
import style0 from "./AdminArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports